<template>
  <generic-container
    icon="student"
    :title="$t('student portal')"
    :configurable="true"
    v-bind:configure_modal="configure_modal"
  >
    <!-- <div class="ui top attached tabular two item menu" ref="tabs">
      <a class="active item" data-tab="first">
        <i class="users icon"></i> {{ $t("users") }}</a
      >
      <a class="item" data-tab="second">Second</a>
    </div>
    <div class="ui bottom attached active tab segment" data-tab="first"> -->
    <users />
    <!-- </div>
    <div class="ui bottom attached tab segment" data-tab="second">
      Second
    </div> -->
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import Users from "./Users.vue";
import ConfigureModal from "@/modules/student_portal/configure_modal/Index.vue";
// @ is an alias to /src
export default {
  name: "StudentPortalIndex",
  components: { Users, GenericContainer },
  data() {
    return {
      configure_modal: ConfigureModal,
    };
  },
  methods: {
    add() {},
  },
  mounted() {
    let vm = this;
    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
};
</script>
